import React, { useState, useEffect } from 'react'
import moment from 'moment'
import {
  CustomerDocument,
  useCustomerUpdateMutation,
  CustomerUpdateInput,
  CustomerQuery,
} from 'lib/graphql/storeadmin'
import {
  Select,
  showMessage,
  Spin,
  Button,
  Card,
  Title,
  Paragraph,
} from 'components/common'

type Props = {
  customer: CustomerQuery['customer']
}

export const SubArenaBookableFlag: React.FC<Props> = (props) => {
  const { customer } = props
  const [flag, setFlag] = useState<boolean>(false)
  const [updateCustomer, { loading: customerUpdateLoading }] =
    useCustomerUpdateMutation({
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: CustomerDocument,
          variables: {
            id: customer?.id,
            future: moment().format('YYYY-MM-DD'),
          },
        },
      ],
    })
  const handleUpdate = async (id: string) => {
    // 初期値から変化なしなら処理を中止する
    if (
      flag ===
      customer.metaFields.edges.some(
        ({ node }) => node.key === 'subarena-permitted'
      )
    )
      return

    const input: CustomerUpdateInput = {
      subArenaBookableFlag: flag,
      prefecturalGroupFlag: !flag
        ? false
        : customer.metaFields.edges.some(
            ({ node }) => node.key === 'local-organization'
          ),
    }

    // 顧客詳細ページでは重複チェックを行わないため、allowDuplicateはtrueにする
    const allowDuplicate = true
    try {
      const { data } = await updateCustomer({
        variables: { allowDuplicate, id, input },
      })
      if (data) {
        showMessage('success', 'サブアリーナ予約可能フラグを更新しました')
      }
    } catch (e) {
      console.log(e)
      showMessage('error', 'データの更新に失敗しました')
    }
  }

  useEffect(() => {
    if (!customer) return
    setFlag(
      customer.metaFields.edges.some(
        ({ node }) => node.key === 'subarena-permitted'
      )
    )
  }, [customer])

  return (
    <Card shadow>
      <Title level={5}>サブアリーナ予約可能フラグの設定</Title>
      <Paragraph mute>
        サブアリーナの予約を制限するためのフラグを設定できます。
        <br />
        予約不可の場合はサブアリーナと付属施設の予約ボタンが表示されなくなります。
      </Paragraph>
      <Spin tip="Loading" size="large" spinning={customerUpdateLoading}>
        <div className="grid grid-cols-3 gap-4">
          <Select
            value={flag}
            onChange={setFlag}
            className="col-span-2"
            options={[
              { value: false, label: '予約不可' },
              { value: true, label: '予約可能' },
            ]}
          />
          <Button type="primary" onClick={() => handleUpdate(customer.id)}>
            更新
          </Button>
        </div>
      </Spin>
    </Card>
  )
}
